import { render, staticRenderFns } from "./AppointmentNotesHistory.vue?vue&type=template&id=12f61fa8&scoped=true"
import script from "./AppointmentNotesHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentNotesHistory.vue?vue&type=script&lang=js"
import style0 from "./AppointmentNotesHistory.vue?vue&type=style&index=0&id=12f61fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f61fa8",
  null
  
)

export default component.exports